import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import { resetScrollPos } from '../../utils/helper-functions';
import ProjectHero from '../../components/project/project-hero';
import ProjectIntroduction from '../../components/project/project-introduction';
import ProjectPagination from '../../components/project/project-pagination';

import ADCaseStudy from './case-studies/ad';
import ADPCaseStudy from './case-studies/adp';
import AllCladCaseStudy from './case-studies/all-clad';
import DupontCaseStudy from './case-studies/dupont';
import HeinekenCaseStudy from './case-studies/heineken';
import LGCaseStudy from './case-studies/lg';
import Philips from './case-studies/philips';
import Ricoh from './case-studies/ricoh';
import SteveMaddenCaseStudy from './case-studies/steve-madden';
import WeichertCaseStudy from './case-studies/weichert-franchising';

import styles from './project.module.css';

class ProjectTemplate extends Component {
  constructor() {
    super();
    this.state = {
      pagination: {},
    };
  }

  getNextProject = currentProject => {
    const { projects } = this.props;
    const { slug } = this.props.data.allWordpressWpWork.edges[0].node;
    const first = projects[0];
    const current = projects.findIndex(obj => obj.slug === slug);
    const next = projects[current + 1];

    if (typeof next !== 'undefined') {
      this.setState({
        pagination: next,
      });
    } else {
      this.setState({
        pagination: first,
      });
    }
  };

  componentDidMount() {
    resetScrollPos();
    this.props.hideHeaderBackdrop();
    this.getNextProject(this.props.slug);
  }

  render() {
    const { pagination } = this.state;
    const {
      title,
      slug,
      featured_media,
      content,
      acf,
    } = this.props.data.allWordpressWpWork.edges[0].node;
    const settings = {
      currentPage: 'ProjectTemplate',
      title: acf.meta_title,
      meta: [
        {
          title: acf.meta_title,
          name: 'description',
          content: acf.meta_description,
        },
      ],
    };

    const renderCaseStudy = slug => {
      switch (slug) {
        case 'ad':
          return <ADCaseStudy slug={slug} acf={acf} />;
          break;
        case 'adp':
          return <ADPCaseStudy slug={slug} acf={acf} />;
          break;
        case 'all-clad':
          return <AllCladCaseStudy acf={acf} />;
          break;
        case 'dupont':
          return <DupontCaseStudy acf={acf} />;
          break;
        case 'heineken':
          return <HeinekenCaseStudy acf={acf} />;
          break;
        case 'lg':
          return <LGCaseStudy acf={acf} />;
          break;
        case 'philips':
          return <Philips acf={acf} />;
        case 'ricoh':
          return <Ricoh acf={acf} />;
        case 'steve-madden':
          return <SteveMaddenCaseStudy acf={acf} />;
          break;
        case 'weichert-franchising':
          return <WeichertCaseStudy acf={acf} />;
        default:
          break;
      }
    };
    return (
      <React.Fragment>
        <Helmet title={settings.title} meta={settings.meta} />
        <div className={styles.wrapper}>
          <ProjectHero
            title={title}
            slug={slug}
            headline={acf.headline}
            featuredImage={featured_media}
            featuredMobileImage={acf.featured_mobile_image}
            buttonColor={acf.button_color}
            currentPage={settings.currentPage}
            browserDetect={this.props.browserDetect}
          />
          <div className={styles.container}>
            <ProjectIntroduction
              content={content}
              roles={acf.roles}
              slug={slug}
              browserDetect={this.props.browserDetect}
            />
            {renderCaseStudy(slug)}
          </div>
          <ProjectPagination
            title={pagination.title}
            headline={pagination.headline}
            link={pagination.slug}
          />
        </div>
      </React.Fragment>
    );
  }
}

ProjectTemplate.propTypes = {
  browserDetect: PropTypes.string,
};

export default ProjectTemplate;

export const projectQuery = graphql`
  query projectQuery($id: String!) {
    allWordpressWpWork(filter: { id: { eq: $id } }) {
      edges {
        node {
          title
          content
          id
          slug
          featured_media {
            localFile {
              childImageSharp {
                sizes(quality: 100, maxWidth: 2500, maxHeight: 1406) {
                  base64
                  tracedSVG
                  aspectRatio
                  src
                  srcSet
                  srcWebp
                  srcSetWebp
                  sizes
                  originalImg
                  originalName
                }
              }
            }
          }
          acf {
            headline
            roles {
              role
            }
            button_color
            button_color_dark
            featured_mobile_image {
              localFile {
                childImageSharp {
                  sizes(quality: 100) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            desktop_design {
              localFile {
                childImageSharp {
                  sizes(quality: 100, maxWidth: 2500) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            desktop_design_blurb
            desktop_image_background
            slider {
              slide {
                localFile {
                  childImageSharp {
                    sizes(quality: 100) {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
            slider_blurb
            quote
            quote_name
            quote_title
            branded_materials_image {
              localFile {
                childImageSharp {
                  sizes(quality: 100, maxWidth: 2500) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            branded_materials_blurb
            marketing_tiles {
              image {
                localFile {
                  childImageSharp {
                    sizes(quality: 100, maxWidth: 2000, maxHeight: 2000) {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
            marketing_tiles_blurb
            marketing_tiles_secondary {
              image {
                localFile {
                  childImageSharp {
                    sizes(quality: 100) {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
            marketing_tiles_secondary_blurb
            interior_pages {
              image {
                localFile {
                  childImageSharp {
                    sizes(quality: 100, maxWidth: 1519, maxHeight: 3194) {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
            interior_pages_blurb
            mobile {
              image {
                localFile {
                  childImageSharp {
                    sizes(quality: 100, maxWidth: 807) {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
            mobile_blurb
            video_ads {
              video_id
            }
            video_ads_blurb
            video_id
            video_thumbnail {
              localFile {
                childImageSharp {
                  sizes(quality: 100, maxWidth: 1224, maxHeight: 689) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            video_blurb
            video_loop_id
            video_loop_blurb
            ad_stills {
              image {
                localFile {
                  childImageSharp {
                    sizes(quality: 100, maxWidth: 500, maxHeight: 500) {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
            ad_stills_blurb
            logo_work_color
            logo_work_blurb
            full_banner_image {
              localFile {
                childImageSharp {
                  sizes(quality: 100, maxWidth: 2500) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            full_banner_blurb
            creative_snapshot_image {
              localFile {
                childImageSharp {
                  sizes(quality: 100, maxWidth: 2000, maxHeight: 1075) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            creative_snapshot_blurb
            print_ad_images {
              image {
                localFile {
                  childImageSharp {
                    sizes(quality: 100, maxWidth: 1000, maxHeight: 1294) {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                    }
                  }
                }
              }
            }
            print_ad_blurb
            design_element_image {
              localFile {
                childImageSharp {
                  sizes(quality: 100, maxWidth: 2500) {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                  }
                }
              }
            }
            design_element_blurb
            meta_title
            meta_description
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/project/index.js